import DataIsValid from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_rawDataManagerDelegate/dataIsValid.mdx";
import MetadataDidChange from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_rawDataManagerDelegate/metadataDidChange.mdx";
import WillFetchMetadataForState from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_rawDataManagerDelegate/willFetchMetadataForState.mdx";
import DidReceiveMetadataForState from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_rawDataManagerDelegate/didReceiveMetadataForState.mdx";
import * as React from 'react';
export default {
  DataIsValid,
  MetadataDidChange,
  WillFetchMetadataForState,
  DidReceiveMetadataForState,
  React
};